import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'

export const routeFrontOfficeSchoolRankingCommonUser = [
  {
    route: 'Ranking',
    text: 'Classement',
    t: 'routes.frontoffice.school.ranking',
    mobileText: 'Classement',
    icon: EmojiEventsIcon,
    href: '/frontoffice/school/team',
    menuHeader: true,
    position: 900,
    positionMobile: 400,
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    t: 'routes.frontoffice.school.myProfile',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
]
